var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMerolracing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.877 92.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#017461;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_221",
    "data-name": "Trazado 221",
    className: "cls-1",
    d: "M7.624,28.359,22.5.212l7.3.006-.023,28.159L44.59.23l7.365.006L51.921,43.68l-7.674-.006.023-28.159L29.456,43.662l-7.3-.005L22.178,15.5,7.365,43.641,0,43.635Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_222",
    "data-name": "Trazado 222",
    className: "cls-1",
    d: "M57.465.24,83.457.261l0,7.12L65.816,7.367l-.009,10.892,17.638.014-.006,7.117L65.8,25.376l-.009,11.2,17.638.014-.006,7.117-25.992-.021Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_223",
    "data-name": "Trazado 223",
    className: "cls-1",
    d: "M89.645.265l11.14.009c12.13.01,18.744,9.607,18.738,17.467a16.832,16.832,0,0,1-4.155,10.951,49.959,49.959,0,0,1,3.7,14.175l.061.743-8.107-.007-.123-.619a51.041,51.041,0,0,0-2.344-9.408,16.508,16.508,0,0,1-5.014,1.357,48.862,48.862,0,0,1-5.384.181l-.131,8.6-8.54-.007Zm8.89,28.1a15.958,15.958,0,0,0,7.613-1.417c3.9-1.978,5.265-5.566,5.268-9.217,0-5.508-4.014-10.586-11.564-10.591a15.028,15.028,0,0,1-1.671-.063l-.017,21.289Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_224",
    "data-name": "Trazado 224",
    className: "cls-1",
    d: "M122.737,22.014C122.747,9.76,133.151-.009,145.405,0c12.192.01,22.581,9.858,22.571,22.05-.01,12.254-10.353,22.085-22.606,22.076C133.058,44.116,122.727,34.329,122.737,22.014Zm22.639,14.932c7.86.006,14.858-7.043,14.865-14.9A15.315,15.315,0,0,0,145.4,7.182c-7.86-.006-14.92,6.981-14.927,14.841a15.382,15.382,0,0,0,14.9,14.923Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_225",
    "data-name": "Trazado 225",
    className: "cls-1",
    d: "M171.272.33l8.355.007L179.6,36.231l11.821.009-.006,7.55-20.175-.016Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_226",
    "data-name": "Trazado 226",
    className: "cls-1",
    d: "M.158,47.9l11.14.009c12.13.01,18.744,9.607,18.738,17.467a16.832,16.832,0,0,1-4.155,10.951,49.967,49.967,0,0,1,3.7,14.175l.061.743-8.107-.007-.123-.619a51.071,51.071,0,0,0-2.344-9.409,16.452,16.452,0,0,1-5.014,1.358,48.862,48.862,0,0,1-5.384.181l-.13,8.6L0,91.338ZM9.047,76.062a16.515,16.515,0,0,0,6.932-1.17c-1.607-2.477-4.019-5.016-7.3-5.39l-.005,6.56ZM8.687,61.4a17.854,17.854,0,0,1,12.8,7.251,11.652,11.652,0,0,0,.436-3.28c0-5.508-4.014-10.586-11.565-10.592a15.028,15.028,0,0,1-1.671-.063Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_227",
    "data-name": "Trazado 227",
    className: "cls-1",
    d: "M37.213,90.984C43.556,77.36,49.9,63.676,56.181,50.052l.846-1.808.843,1.81c6.5,13.634,12.7,27.328,18.964,40.962l.421.905-8.442-.007L66.826,87.63a19.779,19.779,0,0,1-9.832,2.646,20.322,20.322,0,0,1-9.767-2.6L45.294,91.9l-8.5-.007Zm19.8-24.468-6.7,14.528a16.168,16.168,0,0,0,6.692,2,16.419,16.419,0,0,0,6.816-1.985Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_228",
    "data-name": "Trazado 228",
    className: "cls-1",
    d: "M107.905,83.065l4.266,6.007-.743.309a23.951,23.951,0,0,1-10.337,2.405c-12.316-.01-22.581-9.734-22.571-22.05.01-12.253,10.353-21.961,22.606-21.952a23.908,23.908,0,0,1,10.333,2.36l.742.372-4.337,5.876-.8-.372a14.288,14.288,0,0,0-5.631-1.118,14.853,14.853,0,0,0-.023,29.706,13.1,13.1,0,0,0,5.633-1.109Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_229",
    "data-name": "Trazado 229",
    className: "cls-1",
    d: "M118.205,48.045l8.355.007L126.526,91.5l-8.355-.007Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_230",
    "data-name": "Trazado 230",
    className: "cls-1",
    d: "M133.056,48.243l7.3.006,15.822,26.438.021-26.426,7.612.006-.034,43.444-7.3,0L140.656,64.154l-.022,27.478-7.612-.006Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_231",
    "data-name": "Trazado 231",
    className: "cls-1",
    d: "M200.675,76.827l.006-7.488,13.863.01v.743c-.009,12.254-10.476,21.838-22.667,21.828-12.254-.01-22.643-9.858-22.633-22.112.009-12.315,10.291-22.085,22.668-22.075a24.94,24.94,0,0,1,7.488,1.181l.8.31-3.471,6.433-.8-.187a19.23,19.23,0,0,0-3.589-.5c-7.921-.006-14.858,7.043-14.865,14.9a15.216,15.216,0,0,0,14.841,14.8c5.756,0,10.71-3.828,13.064-7.911Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_232",
    "data-name": "Trazado 232",
    className: "cls-1",
    d: "M219.972,69.96h1.949V89.953H228.4V91.87h-8.425Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_233",
    "data-name": "Trazado 233",
    className: "cls-1",
    d: "M231.949,69.96H233.9V89.953h6.476V91.87h-8.425Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_234",
    "data-name": "Trazado 234",
    className: "cls-1",
    d: "M256.876,91.147a10.485,10.485,0,0,1-4.243.88,11.128,11.128,0,1,1,4.243-21.376l-1.069,1.509a8.346,8.346,0,0,0-3.018-.5,9.262,9.262,0,0,0,0,18.515,8.417,8.417,0,0,0,3.049-.534Z",
    transform: "translate(0.001 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerolracing);
export default __webpack_public_path__ + "static/media/merolracing.f74346af78d14f4edd62bb8cde46a891.svg";
export { ForwardRef as ReactComponent };